import { render, staticRenderFns } from "./OrdersFBATableMobile.vue?vue&type=template&id=50841be4&scoped=true"
import script from "./OrdersFBATableMobile.vue?vue&type=script&lang=js"
export * from "./OrdersFBATableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50841be4",
  null
  
)

export default component.exports